<template>
  <b-table 
    striped 
    sticky-header
    :filter="filter"
    :items="tableDataArray" 
    :fields="fields" 
    :sort-by.sync="sortBy">
    <template #head(lagerMenge)="data">
      <span v-html="convertText(data.label)"></span>
    </template>
    <template #head(lieferungen)="data">
      <span v-html="convertText(data.label)"></span>
    </template>

    <template #cell(bezeichnung)="row">
      {{ row.item.bezeichnung }}
    </template>
    <template #cell(lagerMenge)="row">
      {{ row.item.lagerMenge }}
    </template>
    <template #cell(lieferungen)="row">
      <table class="no-styles w-50">
        <tbody>
          <tr v-for="(seccondelement, index) in row.item.lieferung" :key="`table-${index}`">
            <td class="text-left pr-3">{{seccondelement.menge}}</td>
            <td class="text-right">{{seccondelement.datum | convertDate}}</td>
          </tr>
        </tbody>  
      </table>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'Table',
  props: {
    tableDataArray: Array,
    filter: String
  },
  methods: {
    convertText(value) {
      return value.replace('#','<br>')
    }
  },
  data(){
    return{
      sortBy: 'clNr',
      fields: [
        {
          key: 'clNr',
          label: 'CL Art. Nr.',
          sortable: true
        },
        {
          key: 'hrNr',
          label: 'Herst. Art. Nr.',
          sortable: true
        },
        {
          key: 'bezeichnung',
          label: 'Bezeichnung',
          sortable: true
        },
        {
          key: 'lagerMenge',
          label: 'Aktuell verfügbare#Lagermenge',
          sortable: true
        },
        {
          key: 'lieferungen',
          label: 'Weitere verfügbare Mengen#(terminierte Anlieferung)',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style scoped>
table.no-styles tr {
  background-color: transparent !important;
  border-bottom: 1px solid #dee2e6;
}
table.no-styles tr:last-of-type {
  border-bottom: none;
}
table.no-styles td {
  border: 0;
  padding: 0;
}
</style>

<style>
table thead tr th {
  vertical-align: middle !important;
  border-top: none !important;
}
.b-table-sticky-header {
  margin-bottom: 0 !important;
  max-height: 100% !important;
  height: 100% !important;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
}
.b-table-sticky-header thead {
  position: sticky;
  top: 0;
}
</style>
